export default {
  state: {
    assessmentsFilters: {},
  },

  getters: {
    getAssessmentsFilters: (state) => state.assessmentsFilters,
  },

  mutations: {
    setAssessmentsFilters(state, filters) {
      state.assessmentsFilters = filters;
    },
  },

  actions: {
    changeAssessmentsFilters(context, filters) {
      context.commit("setAssessmentsFilters", filters);
    },
  },
};
